import * as React from 'react';
import {Breadcrumb, Grid, Icon, Input, Popup} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {
    ColumnSelectableComponentProps,
    ColumnSortableComponentProps,
    FilterObjectComponentProps,
    InfinityScrollComponentProps,
    ViewSettingsComponentProps,
    withColumnSelection,
    withColumnSort,
    withFilterObject,
    withInfinityScrollHandlers,
    withPrintAndExport,
    withViewSettings
} from '../../components/DataTable/dataService';
import {DataTable} from '../../components/DataTable/DataTable';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import {ColumnSelectionButton} from '../../components/DataTable/ColumnSelection';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";
import LogisticsAvalancheServiceSingleton from "../../services/LogisticAvalancheService";
import InventoryAccountModal from "../logistics/InventoryAccountModal";
import Moment from "react-moment";
import moment from "moment";
import {GUARD_LOGISTICSPLUS_OR_ADMIN} from "../../routes";

const t = i18n.t.bind(i18n);

if (localStorage.getItem("avalanche_migration") === null) {
    localStorage.removeItem("inventory-avalanche_byaccountlt")
    localStorage.removeItem("inventory-avalanche")
    localStorage.removeItem("inventory-avalanche_byaccountlt_region")
    localStorage.removeItem("inventory-avalanche_byaccountltregion")

    localStorage.setItem("avalanche_migration", "true")
}

const getScrollParent = () => ContentContainer.instance.componentRef.current;

const COLUMNS: ColumnDefinition[] = [
    {
        fieldName: 'kontonummer',
        labelTranslationKey: 'Inventory.Account',
        required: true
    }, {
        fieldName: 'kurzname',
        labelTranslationKey: 'Inventory.ShortName',
        required: true,
        popup: () =>
            <Popup
                style={{paddingLeft: "50px"}}
                position={"right center"}
                trigger={<Icon circular name='info' />}
                content={t("LogisticsAvalanche.shortnameInfo")}
                size='small'

            />,
        cellRender: (v,row) =>  <NavLink
            to={`/logistics/inventory-avalanche-region/${row.kontonummer}/${row.LT}`}>{v}</NavLink>
    },
    {
        fieldName: 'LT',
        labelTranslationKey: 'Inventory.LTNumber',
        required: true,
    },
    {
        fieldName: 'kurztext',
        labelTranslationKey: 'Inventory.ShortText',
        required: true,
        popup: () =>
            <Popup
                style={{paddingLeft: "50px"}}
                position={"right center"}
                trigger={<Icon circular name='info' />}
                content={t("LogisticsAvalanche.shortTextInfo")}
                size='small'
            />,
        cellRender: (v,row) =>  <NavLink
            to={`/logistics/inventory-avalanche/${row.kontonummer}/${row.LT}`}>{v}</NavLink>
    },
    {
        fieldName: 'bestand1',
        labelTranslationKey: 'Inventory.Stock1',
        required: false,
        cellAlign: 'right'
    },
    {
        fieldName: 'bestand2',
        labelTranslationKey: 'Inventory.Stock2',
        required: false,
        cellAlign: 'right'
    },
    {
        fieldName: 'bestand3',
        labelTranslationKey: 'Inventory.Stock3',
        required: false,
        cellAlign: 'right'
    },
    {
        fieldName: 'bestand4',
        labelTranslationKey: 'Inventory.Stock4',
        required: false,
        cellAlign: 'right'
    },
    {
        fieldName: 'bestand5',
        labelTranslationKey: 'Inventory.Stock5',
        required: false,
        cellAlign: 'right'
    },
    {
        fieldName: 'maxDatum',
        labelTranslationKey: 'Inventory.Date',
        required: false,
        cellRender: (v,r) => (v!== "") && <Moment format={t("Common.DateFormat")}>{r.maxDatum + 'T' + r.maxZeit}</Moment>,
        printExportRender: (v,r) => moment(r.maxDatum + 'T' + r.maxZeit).format(t("Common.DateFormat"))
    },
    {
        fieldName: 'maxZeit',
        labelTranslationKey: 'Inventory.Time',
        required: false,
        cellRender: (v,r) => (v!== "") && <Moment format={t("Common.TimeFormat")}>{r.maxDatum + 'T' + r.maxZeit}</Moment>, // to support winter/summer time include date
        printExportRender: (v,r) => moment(r.maxDatum + 'T' + r.maxZeit).format(t("Common.TimeFormat"))
    }

];

const DEFAULT_COLUMNS = COLUMNS.map(c => c.fieldName);

const InventoryAvalanche = (props: RouteComponentProps<any> & InfinityScrollComponentProps & ColumnSelectableComponentProps & ColumnSortableComponentProps & FilterObjectComponentProps & ViewSettingsComponentProps) => {

    if(props.loadingInitial) {
        return <LoadingContainer showLogo={false}/>;
    }
    return (
        <>
            <AnalyticsTracking page="logistics-avalanche" />
            <div className={"sticky-header"}>
                <div className={"ui container"}>

                    <h3><Breadcrumb icon="right angle" sections={[
                        {
                            key: '1',
                            as: NavLink,
                            to:  "/inventory-avalanche/",
                            content: `${t ("Route.InventoryAvalanche")}`,
                        }
                    ]} /></h3>

                    <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>
                    <Grid columns={4} className={"HeadingGrid"} stackable={true}
                          style={{marginBottom: '1em'}}>
                        <Grid.Column width={5}>
                            <InventoryAccountModal chooseFunc={(newFilter: any) => props.handleFilterChange('filter', newFilter.trim())}/>
                        </Grid.Column>
                        <Grid.Column width={5}>
                            <Input fluid icon={'search'} placeholder={
                                GUARD_LOGISTICSPLUS_OR_ADMIN()
                                    ? t("Forms.Placeholder.SearchAdmin")
                                    : t("Forms.Placeholder.Search")} disabled={props.loading}
                                   value={props.filterObject.filter}
                                   onChange={(_,data) => props.handleFilterChange('filter', data.value)}/>
                        </Grid.Column>
                        <Grid.Column width={5}>
                            <ColumnSelectionButton
                                fluid
                                availableColumns={COLUMNS}
                                selectedColumns={props.selectedColumns}
                                onSave={props.updateSelectedColumns}/>
                        </Grid.Column>
                        <Grid.Column width={1}>
                            <div style={{opacity: (props.loading) ? '1.0' : '0.0', width:"100%"}}>
                                <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                                </div>
                            </div>
                        </Grid.Column>
                    </Grid>
                </div>
            </div>
            <div className={"ui container responsivewrapper"}>
                <DataTable
                    columns={COLUMNS}
                    data={props.data}
                    page={props.page}
                    totalPages={props.totalPages}
                    sortDirection={props.sortDirection}
                    sortColumn={props.sortColumn}
                    selectedColumns={props.selectedColumns}
                    getScrollParent={getScrollParent}
                    loadMore={props.loadMore}
                    handleSortChange={props.handleSortChange}
                    loading={props.loading}
                    filter={props.filterObject}
                />
                <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
                    <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                    </div>
                </div>
                <div style={{height: '2em'}}/>
            </div>
        </>
    )
};

const dataService = {
    loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }): Promise<any> {
        return  LogisticsAvalancheServiceSingleton.getAllInventoryData(sortColumn, sortOrder, page, 50, filter.filter ? filter.filter : "");
    }
};

const InventoryAvalancheWrapped = withRouter(withViewSettings(withFilterObject(withColumnSort(withColumnSelection(withPrintAndExport(withInfinityScrollHandlers(InventoryAvalanche)))))));

export default () => (
    <InventoryAvalancheWrapped
        viewName="inventory-avalanche"
        dataService={dataService}
        defaultSortDirection="ASC"
        defaultSortColumn="kontonummer"
        defaultColumns={DEFAULT_COLUMNS}
        defaultFilter={{
        }}
        printColumns={COLUMNS}
        printPath={[`${t ("Route.InventoryAvalanche")}`]}
    />
);